/**
 * LocalStorage helper utilities for save/resume functionality.
 */
import { LS_KEYS } from './constants';

/**
 * Save game state to localStorage.
 */
export const saveGameState = (key, state) => {
  try {
    const serialized = JSON.stringify(state);
    localStorage.setItem(key, serialized);
  } catch (err) {
    console.error('Failed to save game state:', err);
  }
};

/**
 * Load game state from localStorage.
 */
export const loadGameState = (key) => {
  try {
    const serialized = localStorage.getItem(key);
    if (!serialized) return null;
    return JSON.parse(serialized);
  } catch (err) {
    console.error('Failed to load game state:', err);
    return null;
  }
};

/**
 * Clear game state from localStorage.
 */
export const clearGameState = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error('Failed to clear game state:', err);
  }
};

/**
 * Save dark mode preference.
 */
export const saveDarkMode = (isDark) => {
  try {
    localStorage.setItem(LS_KEYS.DARK_MODE, JSON.stringify(isDark));
  } catch (err) {
    console.error('Failed to save dark mode:', err);
  }
};

/**
 * Load dark mode preference.
 */
export const loadDarkMode = () => {
  try {
    const val = localStorage.getItem(LS_KEYS.DARK_MODE);
    if (val === null) return false;
    return JSON.parse(val);
  } catch (err) {
    return false;
  }
};

/**
 * Save theme preference.
 */
export const saveTheme = (theme) => {
  try {
    localStorage.setItem(LS_KEYS.THEME, theme);
  } catch (err) {
    console.error('Failed to save theme:', err);
  }
};

/**
 * Load theme preference.
 */
export const loadTheme = () => {
  try {
    const theme = localStorage.getItem(LS_KEYS.THEME);
    return theme || 'default';
  } catch (err) {
    console.error('Failed to load theme:', err);
    return 'default';
  }
};
